import { useEffect, memo } from "react";

const ScrollRevealWatcher = memo(() => {
  useEffect(() => {
    const obs = new IntersectionObserver(
      entries => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add("in"); }),
      { threshold: 0.08 }
    );
    // Observe both existing and future .rv elements
    const observe = () => document.querySelectorAll(".rv:not(.in)").forEach(el => obs.observe(el));
    observe();
    // Re-observe after short delay for dynamically rendered sections
    const t = setTimeout(observe, 500);
    return () => { obs.disconnect(); clearTimeout(t); };
  }, []);
  return null;
});

export default ScrollRevealWatcher;